import { KbGuidePage } from "@/components/kb/KbGuidePage";

export function Guide005MyelinStoryScriptImproved() {
  return <KbGuidePage slug="guide-005-myelin-story-script-improved" />;
}

(Guide005MyelinStoryScriptImproved as unknown as { path: string }).path = "/guides/myelin-story-script-improved";
